"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemClassNotFoundError = exports.getItemProgram = exports.ItemClassWrapper = exports.ItemProgram = void 0;
const sol_kit_1 = require("@raindrop-studios/sol-kit");
const anchor_1 = require("@project-serum/anchor");
const programIds_1 = require("../constants/programIds");
const ItemInstruction = __importStar(require("../instructions/item"));
const item_1 = require("../state/item");
const pda_1 = require("../utils/pda");
const item_2 = require("../constants/item");
const main_1 = require("../main");
class ItemProgram extends sol_kit_1.Program.Program {
    constructor() {
        super();
        this.PROGRAM_ID = programIds_1.ITEM_ID;
        this.instruction = new ItemInstruction.Instruction({ program: this });
    }
    async fetchItemClass(mint, index) {
        const itemClass = (await pda_1.getItemPDA(mint, index))[0];
        // Need a manual deserializer due to our hack we had to do.
        const itemClassObj = await this.client.provider.connection.getAccountInfo(itemClass);
        if (!(itemClassObj === null || itemClassObj === void 0 ? void 0 : itemClassObj.data)) {
            return Promise.resolve(null);
        }
        const ic = item_1.decodeItemClass(itemClassObj.data);
        return new ItemClassWrapper({
            program: this,
            key: itemClass,
            data: itemClassObj.data,
            object: ic,
        });
    }
    async createItemClass(args, accounts, additionalArgs, options) {
        const instruction = await this.instruction.createItemClass(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async updateItemClass(args, accounts, additionalArgs, options) {
        const instruction = await this.instruction.updateItemClass(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async createItemEscrow(args, accounts, additionalArgs, options) {
        const instruction = await this.instruction.createItemEscrow(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async completeItemEscrowBuildPhase(args, accounts, additionalArgs, options) {
        const instruction = await this.instruction.completeItemEscrowBuildPhase(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async deactivateItemEscrow(args, accounts, additionalArgs, options) {
        const instruction = await this.instruction.deactivateItemEscrow(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async updateValidForUseIfWarmupPassed(args, accounts, additionalArgs = {}, options) {
        const instruction = await this.instruction.updateValidForUseIfWarmupPassed(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async addCraftItemToEscrow(args, accounts, additionalArgs, options) {
        const signers = [];
        const craftItemTransferAuthority = anchor_1.web3.Keypair.generate();
        signers.push(craftItemTransferAuthority);
        const instructions = await this.instruction.addCraftItemToEscrow(args, {
            ...accounts,
            craftItemTransferAuthority: craftItemTransferAuthority.publicKey,
        }, { additionalArgs });
        return this.sendWithRetry(instructions, signers, options);
    }
    async removeCraftItemFromEscrow(args, accounts, additionalArgs, options) {
        const instruction = await this.instruction.removeCraftItemFromEscrow(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async beginItemActivation(args, accounts, additionalArgs = {}, options) {
        const itemClass = await this.fetchItemClass(args.itemClassMint, args.classIndex);
        if (!itemClass) {
            throw new ItemClassNotFoundError("Please double check the specified itemClassMint and classIndex");
        }
        const instruction = await this.instruction.beginItemActivation({ ...args, itemClass }, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async endItemActivation(args, accounts, additionalArgs = {}, options) {
        const signers = [];
        let itemTransferAuthority = accounts.itemTransferAuthority;
        if (!itemTransferAuthority &&
            accounts.itemAccount &&
            accounts.itemAccount.equals((await pda_1.getAtaForMint(accounts.itemMint, this.client.provider.wallet.publicKey))[0])) {
            itemTransferAuthority = anchor_1.web3.Keypair.generate();
            signers.push(itemTransferAuthority);
        }
        const instruction = await this.instruction.endItemActivation(args, { ...accounts, itemTransferAuthority }, additionalArgs);
        return this.sendWithRetry(instruction, signers, options);
    }
    async drainItemEscrow(args, accounts, additionalArgs = {}, options) {
        const instruction = await this.instruction.drainItemEscrow(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async startItemEscrowBuildPhase(args, accounts, additionalArgs, options) {
        const instruction = await this.instruction.startItemEscrowBuildPhase(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    async updateItem(args, accounts, additionalArgs, options) {
        const instruction = await this.instruction.updateItem(args, accounts, additionalArgs);
        return this.sendWithRetry(instruction, [], options);
    }
    //
    // v1
    //
    async createItemClassV1(args, options) {
        const [itemClass, itemsKp, instructions] = await this.instruction.createItemClassV1(args);
        const result = await this.sendWithRetry(instructions, [itemsKp], options);
        return [itemClass, result];
    }
    // TODO: chunk the returned instructions
    async addItemsToItemClass(accounts, options) {
        const ixns = await this.instruction.addItemsToItemClass(accounts);
        return await this.sendWithRetry(ixns, [], options);
    }
    async createRecipe(accounts, args, options) {
        const ix = await this.instruction.createRecipe(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async startBuild(accounts, args, options) {
        const ix = await this.instruction.startBuild(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async addIngredient(accounts, args, options) {
        const ixns = await this.instruction.addIngredient(accounts, args);
        return await this.sendWithRetry(ixns, [], options);
    }
    async verifyIngredient(accounts, args, options) {
        const ix = await this.instruction.verifyIngredient(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async verifyIngredientTest(accounts, args, options) {
        const ix = await this.instruction.verifyIngredientTest(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async completeBuild(accounts, args, options) {
        const ix = await this.instruction.completeBuild(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async receiveItem(accounts, options) {
        const ixns = await this.instruction.receiveItem(accounts);
        return await this.sendWithRetry(ixns, [], options);
    }
    async applyBuildEffect(accounts, options) {
        const ix = await this.instruction.applyBuildEffect(accounts);
        return await this.sendWithRetry([ix], [], options);
    }
    async returnIngredient(accounts, options) {
        const ixns = await this.instruction.returnIngredient(accounts);
        return await this.sendWithRetry(ixns, [], options);
    }
    async destroyIngredient(accounts, options) {
        const ixns = await this.instruction.destroyIngredient(accounts);
        return await this.sendWithRetry(ixns, [], options);
    }
    async closeBuild(accounts, options) {
        const ix = await this.instruction.closeBuild(accounts);
        return await this.sendWithRetry([ix], [], options);
    }
    async addPayment(accounts, options) {
        const ix = await this.instruction.addPayment(accounts);
        return await this.sendWithRetry([ix], [], options);
    }
    async getItemClassV1(itemClass) {
        const itemClassData = await this.client.account.itemClassV1.fetch(itemClass);
        if (!itemClassData) {
            return null;
        }
        const recipeIndex = new anchor_1.BN(itemClassData.recipeIndex);
        const recipes = [];
        for (let i = 0; i <= recipeIndex.toNumber(); i++) {
            const recipeAddr = main_1.Utils.PDA.getRecipe(itemClass, new anchor_1.BN(i));
            const recipeData = await this.client.account.recipe.fetch(recipeAddr);
            // get recipe ingredients
            const ingredients = [];
            for (const recipeIngredient of recipeData.ingredients) {
                const ingredient = {
                    itemClass: new anchor_1.web3.PublicKey(recipeIngredient.itemClass),
                    requiredAmount: new anchor_1.BN(recipeIngredient.requiredAmount),
                    buildEffect: recipeIngredient.buildEffect,
                };
                ingredients.push(ingredient);
            }
            // get payment data
            let payment = null;
            if (recipeData.payment) {
                payment = {
                    amount: new anchor_1.BN(recipeData.payment.amount),
                    treasury: new anchor_1.web3.PublicKey(recipeData.payment.treasury),
                };
            }
            const recipe = {
                itemClass: itemClass,
                recipeIndex: new anchor_1.BN(i),
                payment: payment,
                buildEnabled: recipeData.buildEnabled,
                ingredients: ingredients,
            };
            recipes.push(recipe);
        }
        const itemClassV1 = {
            authority: new anchor_1.web3.PublicKey(itemClassData.authority),
            items: new anchor_1.web3.PublicKey(itemClassData.items),
            recipeIndex: recipeIndex,
            recipes: recipes,
        };
        return itemClassV1;
    }
    async getBuild(build) {
        let buildDataRaw;
        try {
            buildDataRaw = await this.client.account.build.fetch(build);
        }
        catch (_e) {
            return null;
        }
        const buildIngredientData = [];
        for (const rawIngredient of buildDataRaw.ingredients) {
            const mints = [];
            for (const rawIngredientMint of rawIngredient.mints) {
                mints.push({
                    mint: new anchor_1.web3.PublicKey(rawIngredientMint.mint),
                    buildEffectApplied: rawIngredientMint.buildEffectApplied,
                });
            }
            buildIngredientData.push({
                itemClass: new anchor_1.web3.PublicKey(rawIngredient.itemClass),
                currentAmount: new anchor_1.BN(rawIngredient.currentAmount),
                requiredAmount: new anchor_1.BN(rawIngredient.requiredAmount),
                buildEffect: rawIngredient.buildEffect,
                mints: mints,
            });
        }
        let itemMint = null;
        if (buildDataRaw.itemMint !== null) {
            itemMint = new anchor_1.web3.PublicKey(buildDataRaw.itemMint);
        }
        // detect payment
        let paymentData = null;
        const payment = buildDataRaw.payment;
        if (payment !== null) {
            paymentData = {
                paid: payment.paid,
                paymentDetails: {
                    treasury: new anchor_1.web3.PublicKey(payment.paymentDetails.treasury),
                    amount: new anchor_1.BN(payment.paymentDetails.amount),
                },
            };
        }
        const buildData = {
            recipeIndex: new anchor_1.BN(buildDataRaw.recipeIndex),
            builder: new anchor_1.web3.PublicKey(buildDataRaw.builder),
            itemClass: new anchor_1.web3.PublicKey(buildDataRaw.itemClass),
            itemMint: itemMint,
            payment: paymentData,
            ingredients: buildIngredientData,
            status: item_1.convertToBuildStatus(buildDataRaw.status),
        };
        return buildData;
    }
    async getItemV1(item) {
        let itemDataRaw;
        try {
            itemDataRaw = await this.client.account.itemV1.fetch(item);
        }
        catch (_e) {
            return null;
        }
        let cooldown = null;
        if (itemDataRaw.itemState.nonFungible.cooldown !== null) {
            cooldown = new anchor_1.BN(itemDataRaw.itemState.nonFungible.cooldown);
        }
        const itemData = {
            initialized: itemDataRaw.initialized,
            itemMint: new anchor_1.web3.PublicKey(itemDataRaw.itemMint),
            itemState: {
                cooldown: cooldown,
                durability: new anchor_1.BN(itemDataRaw.itemState.nonFungible.durability),
            },
        };
        return itemData;
    }
    async getRecipe(recipe) {
        let recipeDataRaw;
        try {
            recipeDataRaw = await this.client.account.recipe.fetch(recipe);
        }
        catch (_e) {
            return null;
        }
        let payment = null;
        if (recipeDataRaw.payment) {
            payment = {
                treasury: new anchor_1.web3.PublicKey(recipeDataRaw.payment.treasury),
                amount: new anchor_1.BN(recipeDataRaw.payment.amount),
            };
        }
        const ingredients = [];
        for (const ingredient of recipeDataRaw.ingredients) {
            ingredients.push({
                itemClass: new anchor_1.web3.PublicKey(ingredient.itemClass),
                requiredAmount: new anchor_1.BN(ingredient.requiredAmount),
                buildEffect: ingredient.buildEffect,
            });
        }
        const recipeData = {
            recipeIndex: new anchor_1.BN(recipeDataRaw.recipeIndex),
            itemClass: new anchor_1.web3.PublicKey(recipeDataRaw.itemClass),
            buildEnabled: recipeDataRaw.buildEnabled,
            payment: payment,
            ingredients: ingredients,
        };
        return recipeData;
    }
}
exports.ItemProgram = ItemProgram;
ItemProgram.PREFIX = item_2.PREFIX;
class ItemClassWrapper {
    constructor(args) {
        this.program = args.program;
        this.key = args.key;
        this.object = args.object;
        this.data = args.data;
    }
}
exports.ItemClassWrapper = ItemClassWrapper;
async function getItemProgram(anchorWallet, env, customRpcUrl) {
    if (anchorWallet.secretKey) {
        return ItemProgram.getProgramWithWalletKeyPair(ItemProgram, anchorWallet, env, customRpcUrl);
    }
    return ItemProgram.getProgramWithWallet(ItemProgram, anchorWallet, env, customRpcUrl);
}
exports.getItemProgram = getItemProgram;
class ItemClassNotFoundError extends Error {
    constructor(message) {
        super(`ItemClass Not Found: ${message}`);
        // Set the prototype explicitly
        // Ref: https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, Error.prototype);
    }
}
exports.ItemClassNotFoundError = ItemClassNotFoundError;
